import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as serverConfigThunks from './thunk';

export type ServerConfigState = {
  standinBaseUrl: string;
  standinWifiSsids: string;
  isLocalServer: boolean;
  isDirty: boolean;
  isLoading: boolean;
  isStandinEnabled: boolean;
  standinTargetToken: string;
  isBackupLoading: boolean;
};

const initialState: ServerConfigState = {
  standinBaseUrl: '',
  standinWifiSsids: '',
  isLocalServer: false,
  isDirty: false,
  isLoading: false,
  isStandinEnabled: false,
  standinTargetToken: '',
  isBackupLoading: false,
};

const serverConfigSlice = createSlice({
  name: 'serverConfig',
  initialState,
  reducers: {
    setServerConfig: (
      state,
      action: PayloadAction<{
        standinBaseUrl: string;
        standinWifiSsids: string;
        isLocalServer: boolean;
      }>
    ) => {
      Object.assign(state, action.payload);
      state.isDirty = false;
      state.isLoading = false;
    },
    updateServerConfig: (
      state,
      action: PayloadAction<Partial<Pick<ServerConfigState, 'standinBaseUrl' | 'standinWifiSsids'>>>
    ) => {
      Object.assign(state, action.payload);
      state.isDirty = true;
    },
    setServerConfigLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setBackupRegistration: (
      state,
      action: PayloadAction<{ isStandinEnabled: boolean; standinTargetToken: string }>
    ) => {
      state.isStandinEnabled = action.payload.isStandinEnabled;
      state.standinTargetToken = action.payload.standinTargetToken;
    },
    setBackupLoading: (state, action: PayloadAction<boolean>) => {
      state.isBackupLoading = action.payload;
    },
  },
});

export { serverConfigSlice, serverConfigThunks };
